import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "./auth.scss";
import {
  sendemailotp,
  sendwhatsappsmsotp,
  verifyemailotp,
  verifywhatsappsmsotp,
  createLoginLog,
  SAsendemailotp,
  SAsendwhatsappsmsotp,
} from "../services/api/AuthApi.js";
import { useAuth } from "../context/AuthContext.js";
import gsap from "gsap";

import slide1 from "../assets/images/auth3main.jpg";
import slide2 from "../assets/images/auth3main.jpg";
import slide3 from "../assets/images/auth3main.jpg";
import logodark from "../assets/images/dark-main-pro.jpeg";

import google from "../assets/images/Googlelogo.png";
import facebook from "../assets/images/facebook1.png";
import { getAllGlobalSettingsData } from "../services/api/GlobalSettingsApi.js";
import { useGlobalSettings } from "../context/GlobalSettingsContext.js";
import { getAllBubbleData } from "../services/api/NotificationsApi.js";
import { useBubbleSettings } from "../context/BubbleSettingsContext.js";
import JusticeLoader from "../components/JusticeLoader/JusticeLoader.js";
import {resetLogoutFlag} from '../services/api/axios.js';

// const fetchIPAddress = async () => {
//   try {
//     const response = await fetch("https://api.ipify.org?format=json");
//     if (!response.ok) {
//       throw new Error("Failed to fetch IP address");
//     }
//     const data = await response.json();
//     return data.ip;
//   } catch (error) {
//     console.error("Error fetching IP address:", error);
//     return null;
//   }
// };



const fetchIPAddress = async () => {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    console.log("IP Address fetched:", data.ip);
    return data.ip;
  } catch (error) {
    console.error("Error fetching IP address:", error);
    // Fallback IP or return null
    return "0.0.0.0"; // or return null if you prefer
  }
};

export const Login = () => {
  const { user, accessToken, login, company } = useAuth();
  const [otpRequestLoading, setOtpRequestLoading] = useState(false);
  const [verifyBtnLoading, setVerifyBtnLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [screenSize, setScreenSize] = useState("desktop");
  const [isLoadingUserData, setIsLoadingUserData] = useState(false);

  const { setGlobalSettings } = useGlobalSettings();
  const { setBubbleSettings } = useBubbleSettings();

  const navigate = useNavigate();

  // Function to check if subscription is expired
  const isSubscriptionExpired = useCallback((company) => {
    if (!company?.subscription?.currentPeriodEnd) return false;

    const endDate = new Date(company.subscription.currentPeriodEnd);
    const currentDate = new Date();
    
    return currentDate > endDate;
  }, []);

  const [error, setError] = useState("");
  const [mode, setMode] = useState("mobile");
  const [contact, setContact] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [showAccessDeniedModal, setShowAccessDeniedModal] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(0);
  const otpRefs = useRef([]);

  const fetchAndSetUserData = useCallback(async () => {
    try {
      setIsLoadingUserData(true);

      const settingsRes = await getAllGlobalSettingsData();

      if (settingsRes?.data && typeof settingsRes.data === "object") {
        localStorage.setItem(
          "globalSettings",
          JSON.stringify(settingsRes.data)
        );
        setGlobalSettings(settingsRes.data);
        console.log(
          "Global settings stored successfully:",
          settingsRes.data
        );
      } else {
        console.warn("Invalid global settings response:", settingsRes);
      }

      const bubbleRes = await getAllBubbleData();

      if (bubbleRes?.data && typeof bubbleRes.data === "object") {
        localStorage.setItem("bubbleSettings", JSON.stringify(bubbleRes.data)); // Fixed typo too!
        setBubbleSettings(bubbleRes.data);
        console.log("Bubble settings stored successfully:", bubbleRes.data);
      } else {
        console.warn("Invalid bubble settings response:", bubbleRes);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);

      localStorage.removeItem("globalSettings");
      localStorage.removeItem("bubbleSettings");

      setGlobalSettings(null);
      setBubbleSettings(null);
    } finally {
      setIsLoadingUserData(false);
    }
  }, []);

  // useEffect(() => {
  //   const handleAuthenticatedUser = async () => {
  //     if (user && accessToken) {
  //       console.log("User already authenticated, fetching latest data...");
  //       await fetchAndSetUserData();
        
  //       if (isSubscriptionExpired(company)) {
  //         console.log("Subscription expired, setting flag for modal display");
  //         localStorage.setItem('showSubscriptionExpiredModal', 'true');
  //       }
        
  //       navigate("/home");
  //     }
  //   };

  //   handleAuthenticatedUser();
  // }, [user, accessToken]);


  useEffect(() => {
  let isMounted = true;
  
  const handleAuthenticatedUser = async () => {
    if (user && accessToken && isMounted) {
      console.log("User already authenticated, fetching latest data...");
      await fetchAndSetUserData();
      
      if (isSubscriptionExpired(company)) {
        console.log("Subscription expired, setting flag for modal display");
        localStorage.setItem('showSubscriptionExpiredModal', 'true');
      }
      
      // Use replace to avoid adding to history
      navigate("/home", { replace: true });
    }
  };

  handleAuthenticatedUser();
  
  return () => {
    isMounted = false;
  };
}, []); // Run only once on mount
  useEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 768);

      if (width <= 480) {
        setScreenSize("mobile");
      } else if (width <= 768) {
        setScreenSize("tablet");
      } else if (width <= 1024) {
        setScreenSize("desktop-small");
      } else {
        setScreenSize("desktop");
      }
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  useEffect(() => {
    if (user && accessToken) return;

    const title = document.querySelector(".form-title");
    if (title) {
      const text = title.textContent;
      title.style.opacity = "0";
      title.innerHTML = "";

      text.split("").forEach((char, index) => {
        const span = document.createElement("span");
        span.textContent = char === " " ? "\u00A0" : char;
        span.style.opacity = "0";
        span.style.display = "inline-block";
        title.appendChild(span);
      });

      title.style.opacity = "1";

      // Adjust animation delay based on screen size
      const delay = isMobile ? 0.03 : 0.05;

      title.querySelectorAll("span").forEach((span, index) => {
        gsap.to(span, {
          opacity: 1,
          duration: 0.3,
          delay: index * delay,
          ease: "power2.out",
        });
      });
    }
  }, [isMobile, user, accessToken]);

  useEffect(() => {
    if (otpSent && timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(countdown);
    }
  }, [otpSent, timer]);

  const handleContactChange = (e) => {
    setContact(e.target.value);
    setError("");
  };

  const handleOtpChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, "");

    // Handle multiple digits pasted in one input
    if (value.length > 1) {
      const digits = value.slice(0, 6);
      const newOtp = Array(6).fill("");

      for (let i = 0; i < digits.length && i < 6; i++) {
        newOtp[i] = digits[i];
      }

      setOtp(newOtp);
      console.log("PASTE - New OTP:", newOtp, "Joined:", newOtp.join(""));

      const nextIndex = Math.min(digits.length - 1, 5);
      setTimeout(() => {
        otpRefs.current[nextIndex]?.focus();
      }, 0);

      return;
    }

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    console.log(
      "TYPING - Index:",
      index,
      "Value:",
      value,
      "New OTP:",
      newOtp,
      "Joined:",
      newOtp.join("")
    );

    // Enhanced animation for mobile
    if (value) {
      gsap.fromTo(
        otpRefs.current[index],
        { scale: 0.9 },
        {
          scale: 1,
          duration: isMobile ? 0.15 : 0.2,
          ease: "back.out(1.7)",
        }
      );
    }

    // Move to next input
    if (index < otp.length - 1 && value) {
      setTimeout(() => {
        otpRefs.current[index + 1]?.focus();
      }, 0);
    }

    // Check if OTP is complete and auto-submit
    if (value) {
      const isComplete = newOtp.every((digit) => digit !== "");

      console.log(
        "AUTO-SUBMIT CHECK - isComplete:",
        isComplete,
        "newOtp:",
        newOtp
      );

      if (isComplete) {
        setTimeout(() => {
          console.log(
            "AUTO-SUBMIT FINAL - newOtp:",
            newOtp,
            "Joined:",
            newOtp.join("")
          );

          // Use newOtp directly instead of relying on state
          if (newOtp.every((digit) => digit !== "" && digit.length === 1)) {
            console.log("AUTO-SUBMIT TRIGGERED");
            // Pass the complete OTP directly to avoid state timing issues
            handleVerifyOtpWithData(newOtp);
          }
        }, 500);
      }
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const newOtp = [...otp];

      if (newOtp[index]) {
        // Clear current field
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        // Move to previous field and clear it
        newOtp[index - 1] = "";
        setOtp(newOtp);
        otpRefs.current[index - 1]?.focus();
      }
    }
  };

  const handleOtpPaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text");
    const digits = pastedData.replace(/\D/g, "").slice(0, 6);

    if (digits.length > 0) {
      const newOtp = Array(6).fill("");
      digits.split("").forEach((digit, index) => {
        if (index < 6) newOtp[index] = digit;
      });
      setOtp(newOtp);

      // Focus on the last filled input or next empty one
      const nextIndex = Math.min(digits.length, 5);
      otpRefs.current[nextIndex]?.focus();
    }
  };

  const validateContact = () => {
    if (mode === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(contact);
    } else {
      const phoneRegex = /^[6-9]\d{9}$/;
      return phoneRegex.test(contact);
    }
  };
  //merge

  const handleSendOtp = async () => {
    if (!contact.trim()) {
      setError(
        `Please enter your ${
          mode === "email" ? "email address" : "mobile number"
        }`
      );
      return;
    }

    if (!validateContact()) {
      setError(
        mode === "email"
          ? "Please enter a valid email address"
          : "Please enter a valid 10-digit mobile number"
      );
      return;
    }

    setOtpRequestLoading(true);
    setError("");

    try {
      let response;

      if (mode === "email") {
        response = await SAsendemailotp({ email: contact });
      } else if (mode === "mobile") {
        response = await SAsendwhatsappsmsotp({ phone: contact });
      }

       if (response?.data?.error === "User not found") {
         setError("User NOT Found")
        setContact("");
        return;
      }

      if (response?.data?.error === "Access denied. Only Super Admins can log in.") {
       setShowAccessDeniedModal(true);
        setContact("");
        return;
      }

      // Check if user or company account is deactivated
      if (response?.data?.userActiveStatus === false || response?.data?.companyActiveStatus === false) {
        setError(response.data.message || "Your account is deactivated. Please contact support.");
        setOtpSent(false);
        setOtp(["", "", "", "", "", ""]);
        setTimer(0);
        return;
      }

      // If we reach here, OTP was sent successfully
      setOtpSent(true);
      setTimer(60);
      setOtp(["", "", "", "", "", ""]);
      setError("");

      setTimeout(() => {
        otpRefs.current[0]?.focus();
      }, 100);

    } catch (err) {
      // Handle different types of errors
      if (
        err.response?.data?.userActiveStatus === false ||
        err.response?.data?.companyActiveStatus === false
      ) {
        setError(err.response.data.message || "Your account is deactivated. Please contact support.");
        // Make sure OTP section is NOT shown
        setOtpSent(false);
        setOtp(["", "", "", "", "", ""]);
        setTimer(0);
      } else if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError("Failed to send OTP. Please try again.",err);
      }
    } finally {
      setOtpRequestLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    await handleVerifyOtpWithData();
  };

const handleVerifyOtpWithData = async (otpData = null) => {
  console.log("=== VERIFY OTP WITH DATA CALLED ===");

  const currentOtp = otpData || [...otp];
  const enteredOtp = currentOtp.join("");

  if (enteredOtp.length !== 6) {
    setError("Please enter the complete 6-digit OTP");
    return;
  }

  // Fetch IP address first
  const userIP = await fetchIPAddress();
  console.log("User IP for logging:", userIP);

  try {
    setVerifyBtnLoading(true);
    setError("");
    let res;

    if (mode === "email") {
      res = await verifyemailotp({ email: contact, otp: enteredOtp });
    } else if (mode === "mobile") {
      res = await verifywhatsappsmsotp({ phone: contact, otp: enteredOtp });
    }

    console.log("API Response:", res);
    const { accessToken, company, name, role, visibility, email } = res.data;
    resetLogoutFlag();

    // Set user authentication FIRST to get the token in context
    login({ name, [mode]: contact, email }, accessToken, company, role, visibility);

    // NOW create SUCCESS login log (after authentication is set)
    try {
      const logData = {
        ip: userIP || "0.0.0.0",
        type: mode === "email" ? "email" : "whatsapp", 
        status: "success",
        companyId: company._id
      };
      
      console.log("Creating SUCCESS login log with data:", logData);
      // The login function should have set the token, so this should work now
      const logResponse = await createLoginLog(logData);
      console.log("SUCCESS login log created:", logResponse);
    } catch (logError) {
      console.error("Error creating SUCCESS login log:", logError);
      console.error("Log error details:", logError.response?.data || logError.message);
    }

    // Fetch and set all required data
    await fetchAndSetUserData();
    
    // // Check if subscription is expired after successful login
    // if (isSubscriptionExpired(company)) {
    //   console.log("Subscription expired after login, setting flag for modal display");
    //   // Store a flag to show the modal when DisplayBoard loads
    //   localStorage.setItem('showSubscriptionExpiredModal', 'true');
    // }
    
    navigate("/home");
    
  } catch (err) {
    console.log("API Error:", err);
    
    // For FAILED login, we don't have a token, so we need a different approach
    // Option A: Make a public API call for failed logins
    // Option B: Skip logging failed attempts
    // Option C: Use a different endpoint that doesn't require auth
    
    try {
      const logData = {
        ip: userIP || "0.0.0.0",
        type: mode === "email" ? "email" : "whatsapp",
        status: "failed"
      };
      
      console.log("Creating FAILED login log with data:", logData);
      
      // You might need a separate endpoint for failed logins that doesn't require auth
      // Or modify your backend to allow unauthenticated POST to login-logs
      const logResponse = await createLoginLog(logData);
      console.log("FAILED login log created:", logResponse);
    } catch (logError) {
      console.error("Error creating FAILED login log:", logError);
    }
    
    setError("Invalid OTP. Please try again.");
        const logData = {
        ip: userIP || "0.0.0.0",
        type: mode === "email" ? "email" : "whatsapp", 
        status: "failed"
      };
    
      // The login function should have set the token, so this should work now
      await createLoginLog(logData);
    setOtp(["", "", "", "", "", ""]);
    setTimeout(() => {
      otpRefs.current[0]?.focus();
    }, 100);
  } finally {
    setVerifyBtnLoading(false);
  }
};

  
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (otpSent) {
        handleVerifyOtp();
      } else {
        handleSendOtp();
      }
    }
  };

  // Show loading screen for authenticated users while fetching data
  if ((user && accessToken) || isLoadingUserData) {
    return (
      <div className="global-loading-overlay">
        <JusticeLoader
          message={isLoadingUserData ? "Loading user data..." : "Loading..."}
          type="gavel"
        />
      </div>
    );
  }

  const SuperAdminAccessDeniedModal = ({ onClose }) => {
  useEffect(() => {
    gsap.fromTo(
      ".access-denied-overlay",
      { opacity: 0 },
      { opacity: 1, duration: 0.3, ease: "power2.out" }
    );
    gsap.fromTo(
      ".access-denied-modal",
      { opacity: 0, scale: 0.8, y: 50 },
      { opacity: 1, scale: 1, y: 0, duration: 0.5, ease: "back.out(1.7)" }
    );
  }, []);

  const handleClose = () => {
    gsap.to(".access-denied-modal", {
      opacity: 0,
      scale: 0.8,
      y: 50,
      duration: 0.3,
      ease: "power2.in",
    });
    gsap.to(".access-denied-overlay", {
      opacity: 0,
      duration: 0.3,
      ease: "power2.in",
      onComplete: onClose,
    });
  };

  return (
    <div className="access-denied-overlay" onClick={handleClose}>
      <div className="access-denied-modal" onClick={(e) => e.stopPropagation()}>
        <div className="access-denied-icon">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="#dc2626" strokeWidth="2"/>
            <path d="M15 9L9 15M9 9l6 6" stroke="#dc2626" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <h2>Access Denied</h2>
        <p className="main-message">Only Super Admins can access this portal</p>
        <p className="contact-info">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
            <path d="M12 16v-4M12 8h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
          If you believe this is an error, please contact your administrator
        </p>
        <button className="close-modal-btn" onClick={handleClose}>
          <span>Understood</span>
        </button>
      </div>
    </div>
  );
};

  return (
    <div className="login-container" onKeyPress={handleKeyPress}>
        {showAccessDeniedModal && (
        <SuperAdminAccessDeniedModal onClose={() => setShowAccessDeniedModal(false)} />
      )}
      {/* Animated Bubbles */}
      <div className="bubble"></div>
      <div className="bubble"></div>
      <div className="bubble"></div>
      <div className="bubble"></div>
      <div className="bubble"></div>
      <div className="bubble"></div>
      <div className="bubble"></div>
      <div className="bubble"></div>
      <div className="bubble"></div>
      <div className="bubble"></div>

      {/* Super Admin Portal Badge - Oval Style */}
      <div className="super-admin-badge">
        <span className="badge-icon">⚖️</span>
        <span className="badge-text">Super Admin Portal</span>
      </div>

      <div className="image-section">
        <div className="image-overlay"></div>
      </div>

      <div className="form-section">
        <div className="main-logo-log">
          <img
            src={logodark}
            alt="Company Logo"
            className="logo-dark-main-login"
            onClick={() => window.open("http://lawsuit-pro.com", "_self")}
            loading="eager"
          />
        </div>

        <div className="auth-form-content">
          {/* <h1 className="form-title">Welcome Back!</h1> */}
          {/* <div className="forgot-password">
            <span className="forgot-password-text">Don't have an account?</span>
            <a
              href="http://lawsuit-pro.com/pricing.html"
              className="forgot-password-link"
            >
              <u>Create a new account now!</u>
            </a>
          </div> */}

          <div className="mode-tabs">
            <button
              className={`mode-tab ${mode === "mobile" ? "active" : ""}`}
              onClick={() => {
                setMode("mobile");
                setContact("");
                setError("");
                setOtpSent(false);
                setOtp(["", "", "", "", "", ""]);
                setTimer(0);
              }}
            >
              MOBILE
            </button>
            <button
              className={`mode-tab ${mode === "email" ? "active" : ""}`}
              onClick={() => {
                setMode("email");
                setContact("");
                setError("");
                setOtpSent(false);
                setOtp(["", "", "", "", "", ""]);
                setTimer(0);
              }}
            >
              EMAIL
            </button>
          </div>

          <form onSubmit={(e) => e.preventDefault()} className="auth-form">
            <div className="input-section">
              <label className="input-label">
                <span className="label-text">
                  {mode === "mobile" ? "Mobile Number" : "Email"}
                </span>
              </label>
              <div className="input-container">
                {mode === "mobile" && (
                  <div className="country-code">
                    <span className="flag">🇮🇳</span>
                    <span>+91</span>
                  </div>
                )}
                <input
                  type={mode === "email" ? "email" : "tel"}
                  placeholder={
                    mode === "email"
                      ? "Enter your email"
                      : "Enter your mobile number"
                  }
                  className="input-field"
                  value={contact}
                  onChange={handleContactChange}
                  required
                  autoComplete={mode === "email" ? "email" : "tel"}
                  inputMode={mode === "email" ? "email" : "numeric"}
                  maxLength={mode === "email" ? undefined : 10}
                />
                {otpSent && timer > 0 && (
                  <button type="button" className="resend-otp-btn" disabled>
                    Resend ({timer}s)
                  </button>
                )}
                {otpSent && timer === 0 && (
                  <button
                    type="button"
                    className="resend-otp-btn"
                    onClick={handleSendOtp}
                    disabled={otpRequestLoading}
                  >
                    {otpRequestLoading ? "Sending..." : "Resend OTP"}
                  </button>
                )}
              </div>
            </div>

            {otpSent && (
              <div className="otp-input-section">
                <label className="input-label">
                  <span className="label-text">Enter OTP</span>
                </label>
                <div className="otp-boxes">
                  {otp.map((digit, idx) => (
                    <input
                      key={idx}
                      type="text"
                      maxLength="1"
                      className="otp-input"
                      value={digit}
                      onChange={(e) => handleOtpChange(e, idx)}
                      onKeyDown={(e) => handleOtpKeyDown(e, idx)}
                      onPaste={idx === 0 ? handleOtpPaste : undefined}
                      ref={(el) => (otpRefs.current[idx] = el)}
                      inputMode="numeric"
                      pattern="[0-9]*"
                      autoComplete="one-time-code"
                    />
                  ))}
                </div>
              </div>
            )}

            {error && (
              <div className="error-message" role="alert">
                {error}
              </div>
            )}

            <button
              type="button"
              className="send-otp-btn"
              onClick={otpSent ? handleVerifyOtp : handleSendOtp}
              disabled={
                (!otpSent && !contact.trim()) ||
                otpRequestLoading ||
                verifyBtnLoading
              }
            >
              {otpSent ? (
                verifyBtnLoading ? (
                  <>
                    <span>Verifying</span>
                    {isMobile && <span>...</span>}
                  </>
                ) : (
                  "LOGIN"
                )
              ) : otpRequestLoading ? (
                <>
                  <span>Sending</span>
                  {isMobile && <span>...</span>}
                </>
              ) : (
                "Send OTP"
              )}
            </button>

            {/* Keep social buttons structure for future use */}
            {/* <div className="auth-divider">
              <span>or continue with</span>
            </div>

            <div className="social-buttons">
              <button type="button" className="social-btn google">
                <img src={google} alt="Google" />
                <span>Login with Google</span>
              </button>
            </div> */}
          </form>
        </div>
      </div>
    </div>
  );
};